const CAP_BITCOIN_DESCENTRALIZACION = {
  title: "Bitcoin y la descentralización",
  sections: [
    {
      heading: "¿Qué significa que Bitcoin sea descentralizado?",
      text: [
        "Bitcoin fue diseñado desde su origen para funcionar de forma plenamente descentralizada. Esto significa que no existe una entidad central como un banco, empresa o gobierno que controle la red, las transacciones o las decisiones del sistema.",
        "En lugar de eso, son miles de participantes independientes, llamados nodos, quienes verifican las operaciones y mantienen el historial de transacciones, actuando mediante consenso colectivo.",
        "Gracias a esto, ninguna persona, empresa o institución puede censurar tu cuenta, bloquear tus fondos o impedir una transacción. La libertad de custodiar y transferir valor es absoluta."
      ]
    },
    {
      heading: "Ventajas de la descentralización",
      list: [
        "Nadie puede bloquear, congelar o censurar tus fondos.",
        "No depende de horarios bancarios ni fronteras geográficas.",
        "No es necesario pedir permiso para usar la red.",
        "Todos pueden verificar el funcionamiento de la red, ya que es pública y transparente.",
        "Las reglas del sistema no pueden modificarse unilateralmente."
      ]
    },
    {
      heading: "Blockchain: la herramienta para la descentralización",
      text: [
        "Bitcoin utiliza un sistema llamado Blockchain para gestionar transacciones y saldos. Esta blockchain funciona como un libro de contabilidad digital, público y distribuido.",
        "Cada bloque contiene transacciones verificadas por los nodos. A medida que los bloques se conectan entre sí, se forma una cadena inmutable. Si alguien intenta modificar un bloque, toda la red lo detectaría inmediatamente.",
        "La combinación de criptografía, consenso y distribución global de la información es lo que garantiza la seguridad y la descentralización del sistema."
      ]
    },
    {
      heading: "Un sistema abierto y libre",
      text: [
        "Cualquier persona puede participar en la red Bitcoin, ya sea como usuario, minero o nodo validador, sin pedir permiso. Esto convierte a Bitcoin en el primer sistema monetario verdaderamente global, accesible y neutral.",
        "Bitcoin no discrimina por país, edad, idioma, banco o estatus económico. Basta con tener acceso a Internet para formar parte del sistema."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "La descentralización es una de las características más importantes e innovadoras de Bitcoin. Gracias a ella, los usuarios tienen plena autonomía sobre su dinero, sin depender de intermediarios.",
        "Bitcoin representa un nuevo modelo de libertad financiera, donde las transacciones son seguras, verificables, irreversibles e incensurables."
      ]
    }
  ]
};

export default CAP_BITCOIN_DESCENTRALIZACION;
